module.exports = "/_next/static/images/top-6c3a98a00d98dac3bc1d0314a75e4c1b.jpg";